<div *ngIf="content$ | async as appContent">
	<form [formGroup]="termsConditionsForm" ngxsForm="termsConditionsState.termsConditionsForm">
		<div class="nha-sa-section remove-for-print">
			<div class="nha-sa-section-header">
				{{ appContent.resourceStrings['nha.sa.termsconditionsheader'] }}
				<span class="nha-pattern-dots"></span>
			</div>
		</div>
		<div class="nha-sa-section remove-for-print">
			<div class="nha-row">
				<div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
					<div class="nha-form-group nha-input-select">
						<label for="guardianSignatureSelect"
							><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.termsconditionsacknowledgetext'] }}</label
						>
						<select id="guardianSignatureSelect" class="nha-form-control remove-for-print" formControlName="termsGuardian" aria-required="true">
							<option *ngFor="let guardian of guardians; let g = index" [value]="guardian.internalGuardianId">
								{{ guardian | fullName : g }}
							</option>
						</select>
					</div>
				</div>
				<div class="nha-gr-12">
					<span class="nha-sa-terms-sublabel">
						{{ appContent.resourceStrings['nha.sa.termsconditionsacknowledgetextparttwo'] }}
						<a href="#termsAndConditions" class="nha-sa-terms-link">{{ appContent.resourceStrings['nha.sa.termsconditionslink'] }}</a>.
					</span>
				</div>
				<div class="nha-gr-12">
					<div class="nha-form-group nha-inline-block nha-form-single-check">
						<input id="termsConditionsCheck" class="nha-input-checkbox" type="checkbox" value="false" formControlName="termsAgree" aria-required="true"/>
						<label for="termsConditionsCheck"
							><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.termsconditionsagree'] }}</label
						>
						<div class="nha-form-error-desc">
							{{ appContent.resourceStrings['nha.sa.errortermsconditionsagree'] }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div [style]="showTermsAndConditions ? 'display: block;' : 'display: none;'">
			<span class="nha-required" aria-hidden="true">*</span>
			<span>
				By signing below, I acknowledge that I am the parent or legal guardian of the child being applied for and I am the one completing this form. In
				addition, by checking the box below, I have read and agree to the Terms & Conditions on the following pages.
			</span>
			<br />
			<br />
			<div class="nha-form-group nha-inline-block nha-form-single-check">
				<input id="termsConditionsCheck" class="nha-input-checkbox" type="checkbox" value="false" formControlName="termsAgree" />
				<label for="termsConditionsCheck"><span class="nha-required" aria-hidden="true">*</span> {{ appContent.resourceStrings['nha.sa.termsconditionsagree'] }}</label>
				<div class="nha-form-error-desc">
					{{ appContent.resourceStrings['nha.sa.errortermsconditionsagree'] }}
				</div>
			</div>
		</div>
	</form>
</div>

<ng-container *ngIf="termsAndConditions$ | async as termsAndConditions">
	<div [style]="showTermsAndConditions ? 'display: block;' : 'display: none;'">
		<div>
			<span>Signature:__________________________________________</span>
			<span style="padding-left: 4px">Date:_____________________</span>
		</div>

		<br />
		<div id="termsAndConditions" [innerHTML]="termsAndConditions" class="application-font-adjust"></div>
	</div>
</ng-container>
